define('views/blocks/AccountNavigationView',['underscore','jquery','backbone','app','hooks','SubView','UrlFactory',
        'TagCommander',
        'template!blocks/account/navigation','InternalLinkView'],
    function (_,$,Backbone,app,hooks,SubView,UrlFactory,
              TagCommander,
              accountNavigationTemplate,InternalLinkView) {

    //
    // Account Navigation View
    // représente le bloc de navigation de la page mon compte
    //

    var view,
        navItemsReady = false,
        navItems = [
            {i:'dashboard',l:'Mon compte',c:''},
            {i:'profile',l:'Mon profil',c:'PROFILE'},
            {i:'loyalty',l:'Mon espace <span>fidélité Come in</span>',c:'LOYALTY'},
             // {i:'sponsorship',l:'Parrainage',c:'SPONSORSHIP'},
             // {i:'payment',l:'Mes moyens de paiement',c:'PAYMENT'},
            {i:'orders',l:'Suivi de commande',c:'ORDERS'},
            {i:'favorites',l:'Mes commandes et produits préférés',c:'FAVORITES'},
        ];

    return Backbone.View.extend(SubView).extend({
        events:{
            'click .customer-link':'trackSupportCenter',
        },
        initialize:function(options) {

            view = this;
            view.subviews = [];
            if(!navItemsReady){
                if(app.hasPaymentModesStorable()){
                    navItems.splice(3, 0, {i:'payment',l:'Mes moyens de paiement',c:'PAYMENT'});
                }
                if (app.c("_ENABLE_PARRAINAGE_MAIL_NEOLANE_") == 1 ){
                    navItems.splice(3, 0, {i:'sponsorship',l:'Parrainage',c:'SPONSORSHIP'});
                }
                navItemsReady = true;
            }
            view.account_page = options.account_page;
            view.customer = options.customer;
            view.render();
            view.listenTo(app, 'changeAccountPage', view.changeAccountPage);
        },

        render:function() {

            if(window.location.search === "?webapps=1") {
              $('.site-header').hide();
              $('.footer').hide();
            }
            var menu = _.pick(view.getNavigationMenu(), function (navItem) {
                return navItem.isEnabled === undefined || navItem.isEnabled;
            });
            view.$el.html(accountNavigationTemplate({
                customer:view.customer,
                menu: menu,
                account_page:view.account_page
            }));

            hooks.execHook('NavExtraData',null,function(extraContentAccount){
            view.$('.extraNavaccountName').append(extraContentAccount);

            });


            InternalLinkView.initializeLinksOfView(view);
            view.delegateEvents();
        },


        getNavigationMenu:function(){
            // fabrique les données du menu
            return _(_(navItems).map(function(item){
                var url,routeName='accountPage',urlOptions = {};
                if(item.i === 'dashboard'){
                    routeName = 'accountDashboard';
                }else{
                    urlOptions.account_rewrite = app.c('_ACCOUNT_'+item.c+'_REWRITE_');
                }
                url = UrlFactory.getUrl(routeName,urlOptions);
                return {
                    name:item.i,
                    label:app.t(item.l,'Account'),
                    url:url
                }
            }));
        },

        trackSupportCenter:function(e){
            TagCommander.eventGA(e.currentTarget,'Compte','Aide');
        },

        changeAccountPage:function(account_page){
            view.account_page = account_page;
            var activeEl = view.$('li.'+account_page),
                navItem = _(navItems).findWhere({i:account_page});
            TagCommander.eventGA(activeEl.get(0),'Compte',navItem.i,navItem.l);
            view.$('li').removeClass('active');
            activeEl.addClass('active');
        }
    });
});

